var execv2 = {
    util: {},
    ui: {},
    messages: {},
    files: {},
    actions: {},
    history: {},
    form: {},
    tutorial: {},
    ownership: {}
};

execv2.util.safeGetElementById = function(id) {
    if (document.getElementById(id) !== null)
        return document.getElementById(id);

    return { "value": "", "innerHTML": "" };
}

execv2.util.isEmbeddedInDockFrame = function () {
    try {
        if (globalThis.self === globalThis.top) return false;

        return new URLSearchParams(globalThis.location.search).get("embed") === "1";
    } catch (error) {
        // Sem acesso ao contexto do frame, assume-se embutido para que a navegação siga pelo frame superior.
        console.warn("Não foi possível verificar o contexto do frame; redirecionando pelo frame superior.", error);
        return true;
    }
}

execv2.util.redirectOutOfDockFrame = function (url) {
    if (execv2.util.isEmbeddedInDockFrame()) {
        window.top.location.href = url;
        return;
    }

    location.href = url;
}

execv2.objects = {
    codFlowExecute: execv2.util.safeGetElementById("inpCodFlowExecute").value,
    codFlowExecuteUID: execv2.util.safeGetElementById("inpCodFlowExecuteUID").value,
    codFlowExecuteMaster: execv2.util.safeGetElementById("inpCodFlowExecuteMaster").value,
    codFlowExecuteTask: execv2.util.safeGetElementById("inpCodFlowExecuteTask").value,
    codFlowExecuteTaskPosition: execv2.util.safeGetElementById("inpCodFlowExecuteTaskPosition").value,
    codFlowElement: execv2.util.safeGetElementById("inpCodFlowElement").value,
    urlToRedirect: execv2.util.safeGetElementById("inpUrlToRedirect").value,
    hidDsActorName: document.getElementById("inpDsActorName"),
    containerActorAvatar: execv2.util.safeGetElementById("containerActorAvatar").innerHTML,
    codFlow: execv2.util.safeGetElementById("inpCodFlow").value,
    codServiceSafeEnc: execv2.util.safeGetElementById("inpCodServiceSafeEnc").value,
    buttons: document.getElementById("controllers"),
    offsetBottom: document.getElementById("offsetBottom"),
    requestScreen: execv2.util.safeGetElementById("inpCodFlowExecute").value === "",
    isTask: execv2.util.safeGetElementById("inpCodFlowExecute").value !== "",
    isRequest: execv2.util.safeGetElementById("inpCodFlowExecute").value === "",
    inpCodUserForwardTo: document.getElementById("inpCodUserForwardTo"),
}

execv2.services = {
    urlFiles: `${smlbpms.baseUrl}api/internal/bpms/1.0/files`,
    urlMessages: `${smlbpms.baseUrl}api/internal/legacy/1.0/messages`,
    urlHistory: `${smlbpms.baseUrl}api/internal/legacy/1.0/history`,
    urlTutorialGet: `${smlbpms.baseUrl}api/internal/bpms/1.0/tutorial/${execv2.objects.codServiceSafeEnc}/published`,
    urlTutorialLike: `${smlbpms.baseUrl}api/internal/bpms/1.0/tutorial/${execv2.objects.codServiceSafeEnc}/like`,
    urlTutorialDislike: `${smlbpms.baseUrl}api/internal/bpms/1.0/tutorial/${execv2.objects.codServiceSafeEnc}/dislike`,
    urlTaskPositionOtherActions: `${smlbpms.baseUrl}api/internal/legacy/1.0/execute/taskposition.aspx?m=isalreadyowner&t=${execv2.objects.codFlowExecuteTask}`,
    urlTakeback: `${smlbpms.baseUrl}api/internal/legacy/1.0/execute/history.aspx?m=take-back&cfe=${execv2.objects.codFlowExecute}`
}


execv2.util.stripHTML = function (s) {
    s = s.replace(/<\/?[^>]+(>|$)/g, "");
    s = s.replace(/(?:\r\n|\r|\n)/g, '<br>');


    return s;
}

execv2.util.breaklineWithBr = function (s) {
    s = s.replace(/(?:\r\n|\r|\n)/g, '<br>');

    return s;
}

execv2.util.htmlEncode = function (s) {
    return filterXSS(s);
}

execv2.util.removeWhiteSpaces = function (o) {
    var node = null;
    while (node = node ? node.nextSibling : o.firstChild) {
        if (node.nodeType == 3 && !/\S/.test(node.nodeValue)) {
            o.removeChild(node);
        }
    }
    if (node || o.firstChild) {
        while (node = node ? node.nextSibling : o.firstChild.firstChild) {
            if (node.nodeType == 3 && !/\S/.test(node.nodeValue)) {
                o.firstChild.removeChild(node);
            }
        }
    }
}

execv2.util.sanitizeTextToConcat = function (s) {

    s = execv2.util.stripHTML(s);
    s = s.replace(/,/g, '!@!');
    s = s.replace(/;/g, '$@$');
    s = s.replace(/"/g, '\\');
    return s;
}

execv2.util.rewriteConcatToText = function (s) {
    s = s.replace(/!@!/g, ',');
    s = s.replace(/\$@\$/g, ';');
    s = s.replace(/\\/g, '"');

    return s;
}

execv2.util.identifyMention = function (s) {
    s = s.replace(/(@[\S]*)/g, '<b>$1</b>');
    return s;
}

execv2.ui = {

    increaseCounter: function (counter) {
        counter.innerHTML = parseInt(counter.innerHTML) + 1;
    },

    resetCounter: function (counter) {
        counter.innerHTML = 0;
    },

    adjustOffsetBottom: function () {
        if (execv2.objects.offsetBottom!==null)
            execv2.objects.offsetBottom.style.height = (buttons.offsetHeight + 30) + "px";
    },

    adjustLegacyMultivaloredTables: function () {

        var tbls = document.querySelectorAll("[mult='S']");

        h.forEach(tbls, function (i, tbl) {

            var container = document.createElement("div");
            container.className = "table-responsive";

            tbl.parentNode.insertBefore(container, tbl);
            container.appendChild(tbl);


            tbl.className = "table table-striped table-bordered";
            tbl.cellPadding = 0;
            tbl.cellSpacing = 0;
            tbl.border = 0;
            tbl.style.display = "";
            tbl.style.width = "100%";

        });

    }
}


execv2.setUploadCallbacks = function (filepath, querystring, filename, fileresume, requestercansee, associatedfieldname, viewercrypt, rowindex, filetype) {

    if (associatedfieldname) {

        execv2.form.fileUpload.add(filename, filepath, associatedfieldname, viewercrypt, rowindex);

    } else {
        execv2.files.add(filename, filepath, fileresume, querystring, requestercansee, filetype);

    }
    captureModule.capture.load();
}

execv2.showControllerBlock = function () {
    document.querySelector('#controllers > #buttons').style.visibility = '';
}

execv2.hideControllerBlock = function () {
    document.querySelector('#controllers > #buttons').style.visibility = 'hidden';
}

execv2.istaskowned  = function () {
    // Quem responde "estou numa página de execução?" é a própria janela, não o parent. A checagem
    // olhava o pathname do parent, o que só funcionava por efeito colateral do modal legado:
    // bsml.modalOpen em size 4/5 trocava a URL da janela hospedeira via history.replaceState
    // (orquestra-bootstrap/dist/assets/js/ui.js), então o parent da lista antiga aparecia como
    // 2.0/task. O painel do dock novo (modules/legacy-modal.js -> dialogs.createOffcanvas) não mexe
    // no history: o parent seguia em /my/tasks, o polling era desligado e a tarefa assumida por
    // outra pessoa nunca redirecionava para a mensagem de "não é mais responsável". Dentro do
    // iframe — modal legado, painel do dock novo ou aba própria — a janela é sempre a execução.
    const isExecutePage = globalThis.location.pathname.includes('2.0/task')
        || globalThis.location.pathname.includes('2.0/request');

    let shouldCheckOwnerShip = isExecutePage
        && execv2.objects.codFlowExecuteTask !== ""
        && execv2.objects.codFlowExecuteTask !== "0";

    // Sem tarefa a acompanhar nem se cria o intervalo: a condição é fixa pela vida da página, então
    // não há o que reavaliar a cada 10s.
    if (!shouldCheckOwnerShip) return;

    async function iamtheowner() {
        if (!shouldCheckOwnerShip) return;

        const data = await execv2.ownership.iAmTheOwner();
        if (data?.error)
            shouldCheckOwnerShip = false;
        else if (!data?.success)
            globalThis.location.reload();
        else if (!globalThis.finishTask)
            execv2.counttasks();
    }

    iamtheowner();
    globalThis.isTaskOwnedId = globalThis.setInterval(iamtheowner, 10000);
}

execv2.counttasks = function () {
    let shouldCountTasks = true;

    async function countTasksJson() {
        let codFlowExecute = document.querySelector('#inpCodFlowExecuteC')?.value;
        let numberOfTasks = document.querySelector('#inpNumberOfTasks')?.value;

        if (!shouldCountTasks || !codFlowExecute) return;

        const data = await execv2.ownership.countTasks();
        if (data?.error)
            shouldCountTasks = false;
        else if (!data?.success || !numberOfTasks) {
            shouldCountTasks = false;
            return;
        }

        numberOfTasks = Number.parseInt(numberOfTasks, 10);

        if (!Number.isNaN(numberOfTasks) && !Number.isNaN(data.success) &&
            (data.success > numberOfTasks) && !globalThis.finishTask) {
            document.querySelector('#controllers button').style.display = 'none'
            document.querySelector('#controllers a').style.display = 'none'
            document.getElementById('divAnotherTaskWasFinalized').classList.remove('hidden');

            // scroll to top
            window.scrollTo(0, 0);

            // stop querying
            shouldCountTasks = false;
        }
    }

    countTasksJson();
}

execv2.stopTaskOwnershipCheck = function () {
    if (globalThis.isTaskOwnedId) {
        globalThis.clearInterval(globalThis.isTaskOwnedId);
        globalThis.isTaskOwnedId = null;
    }
};

execv2.ownership = window.location.pathname.includes('/task') ? new Ownership() : {};

if (execv2.objects.codFlowExecuteTask && execv2.objects.codFlowExecuteTask !== "0") {
    var rowVersion = document.querySelector('#inpRowVersion');
    if (rowVersion && rowVersion.value) {
        ConcurrencyManager.init(execv2.objects.codFlowExecuteTask, rowVersion.value);
    }
}

execv2.ui.adjustOffsetBottom();
execv2.ui.adjustLegacyMultivaloredTables();
upload_callBack = execv2.setUploadCallbacks;

window.addEventListener('beforeunload', () => {
    execv2.stopTaskOwnershipCheck();
    ConcurrencyManager.stopPolling();
});

